import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key from environment
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

/**
 * Redirect to Stripe Checkout for subscription
 * @param {string} sessionId - Checkout session ID from backend
 */
export const redirectToCheckout = async (sessionId) => {
  const stripe = await stripePromise;

  if (!stripe) {
    throw new Error('Stripe failed to load');
  }

  const { error } = await stripe.redirectToCheckout({
    sessionId: sessionId
  });

  if (error) {
    console.error('Stripe redirect error:', error);
    throw error;
  }
};

/**
 * Get Stripe instance for advanced usage
 */
export const getStripe = () => stripePromise;

const stripeService = {
  redirectToCheckout,
  getStripe
};

export default stripeService;

